import perfilImg from "../../assets/perfil.jpg";
import cssImg from "../../assets/css.svg";
import htmlImg from "../../assets/html.svg";
import javascriptImg from "../../assets/javascript.svg";
import reactjsImg from "../../assets/reactjs.svg";
import typescriptImg from "../../assets/typescript.svg";
import styles from "./styles.module.scss";

export function Introduction() {
  return (
    <section
      className={`${styles.IntroductionContainer} ativo`}
      id="srollSuave"
    >
      <div className={styles.blockOne}>
        <h1>
          Desenvolvedor <br /> <span>Full stack Junior</span>
        </h1>
      </div>

      <div className={styles.blockTwo}>
        <h2>
          desenvolvedor web com <span>2 anos</span> de experiencia
        </h2>
        <div>
          <p>minhas primary skills</p>
          <span>
            <img src={cssImg} alt="css" />
            <img src={htmlImg} alt="html" />
            <img src={javascriptImg} alt="javascript" />
            <img src={reactjsImg} alt="react" />
            <img src={typescriptImg} alt="typescript" />
          </span>
        </div>
      </div>

      <div className={styles.blockThree}>
        <p>
          Esté site ainda está em desenvolvimeno e está no ar apenas para testes
        </p>
      </div>

      <img src={perfilImg} className={styles.perfilmg} alt="" />
      <span>Welisson Henrique</span>
      <span>Back End Developer Junior</span>
    </section>
  );
}
